import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";
import { Threshold } from "../../../../../services/cloudchipr.api";

export const currentBudgetThresholdsSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget): Threshold[] | undefined => budget?.body?.thresholds,
);
